import { FC } from 'react';
import MarketplaceFeaturesList from './containers/MarketplaceFeaturesList/MarketplaceFeaturesList';
import MarketplaceFilters from './containers/MarketplaceFilters/MarketplaceFilters';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import CustomTooltip from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Icon from '~/view/components/Controls/Icon/Icon';
import Headers from '~/view/containers/Headers/Headers';
import HeaderTitle from '~/view/containers/Headers/components/HeaderTitle/HeaderTitle';

const MarketplaceScreen: FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <div className="d-flex align-items-center">
          <HeaderTitle title={localeStore.t('marketplace')} />
          <CustomTooltip message={localeStore.t('marketplace_tooltip_msg')} gapTop={-15} minWidth={400}>
            <Icon name={Icons.Info} size={20} color={theme.colors.gray2} className="px-3" />
          </CustomTooltip>
        </div>
      </Headers>
      <MarketplaceFilters />
      <MarketplaceFeaturesList />
    </div>
  );
};

export default MarketplaceScreen;
